import { render, staticRenderFns } from "./ReplenishmentIframe.vue?vue&type=template&id=0124049a&scoped=true&"
import script from "./ReplenishmentIframe.vue?vue&type=script&lang=js&"
export * from "./ReplenishmentIframe.vue?vue&type=script&lang=js&"
import style0 from "./ReplenishmentIframe.vue?vue&type=style&index=0&id=0124049a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0124049a",
  null
  
)

export default component.exports